module.exports = __webpack_public_path__ + "img/img_level_2.020ef58f.png";